import { Button, Modal, notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import React, { useContext, useEffect, useRef, useState } from "react";
import debounce from "lodash/debounce";
import CustomForm from "../CustomForm";
import { useParams } from "react-router-dom";
import { statusControl, statusControlList } from "../../../utils/constants";
import { createPortal } from "react-dom";
import { modalsByContext } from "./modals";
import dayjs from "../../../utils/dayjs";
import {
  setPropertiesPrestation,
  updateControlPrestation,
} from "../../../pages/Prestations/Slices/Prestation.slice";
import { ModalContext } from "../../../engine/context/Modal.provider";
import { UserContext } from "../../../engine/context/User.context";
import { MdOutlineFreeCancellation } from "react-icons/md";

export const PrestationControl = ({ defaultOpen }) => {
  const [modal, contextHolder] = Modal.useModal();

  const [open, setOpen] = useState(defaultOpen);

  useEffect(() => {
    setOpen(defaultOpen);
  }, [defaultOpen]);

  const { prestation, loading } = useSelector(state => state.prestation);
  const context = useContext(ModalContext);
  const { params } = context;

  let init = "";
  let control = "hidden";

  if (params.control === 1) {
    init = prestation.control1?.note;
    control = prestation.control1?.status || statusControl.uncontrolled;
  }

  if (params.control === 2) {
    init = prestation.control2?.note;
    control = prestation.control2?.status || statusControl.uncontrolled;
  }

  const { status } = prestation;
  const { user } = useContext(UserContext);

  const inputs = inputsControl({ prestation, init, control });

  const formRef = useRef(null);

  const dispatch = useDispatch();

  // Prevent rapid multi-clicks: accept first click, ignore subsequent within delay
  const clickGuards = useRef({});
  const preventMultiClick = (key, fn) => {
    if (!clickGuards.current[key]) {
      clickGuards.current[key] = debounce(fn, 800, {
        leading: true,
        trailing: false,
      });
    }
    return clickGuards.current[key];
  };

  const onSubmitForm = async data => {
    let updated = {
      user: user._id,
      at: dayjs().format(),
      note: data.note,
      status: data.status,
    };

    let controle = {};

    if (params.control === 1) {
      controle.control1 = updated;
    }

    if (params.control === 2) {
      controle.control2 = updated;
    }

    await dispatch(setPropertiesPrestation(controle));
    await dispatch(updateControlPrestation());

    close();
  };

  const close = () => {
    setOpen(false);
    context.closeModal(modalsByContext.PrestationControl);
  };

  const config = {
    key: prestation._id + modalsByContext.PrestationControl,
    containerStyle: { minWidth: "500px" },
    title: ` ${
      params.control === 1 ? `1er` : "2ème"
    } contrôle de la prestation`,
    open: open,
    cancelText: "Fermer",
    okText: "Je confirme",
    onOk: preventMultiClick("okSubmit", () => {
      formRef.current.submit();
    }),
    onCancel: preventMultiClick("cancelClose", close),
    content: (
      <>
        <CustomForm
          dataSource={inputs}
          handleSubmit={data => onSubmitForm(data)}
          labelCol={24}
          refForm={formRef}
          wrapperCol={24}
          onValuesChange={undefined}
        />
      </>
    ),
    footer: [
      <Button key="close" onClick={preventMultiClick("footerClose", close)}>
        Fermer
      </Button>,
      <Button
        icon={<MdOutlineFreeCancellation size={20} />}
        type="primary"
        onClick={preventMultiClick("footerConfirm", async () => {
          try {
            const test = await formRef.current.validateFields();
            formRef.current.submit();
          } catch (e) {
            notification.error({
              message: e.errorFields.length + " champs est nécessaire",
            });
          }
        })}
      >
        Confirmer le contrôle
      </Button>,
    ],
  };

  return (
    <>
      {createPortal(
        <Modal {...config}>{config.content}</Modal>,
        document.querySelector("#modals"),
      )}
    </>
  );
};

export const inputsControl = ({ prestation, user, init, control }) => {
  const {} = prestation;
  const { id } = useParams();

  return [
    {
      parentLabel: "",
      children: [
        {
          label: "Status du contrôle",
          key: "status",
          name: "status",
          type: "select",
          value: control,
          col: 24,
          selectContent: statusControlList,
        },
        {
          label: "Remarque sur le contrôle",
          name: "note",
          type: "textarea",
          value: init,
          rows: 4,
          col: 24,
        },
      ],
    },
  ];
};
